import { render, staticRenderFns } from "./notification-bar.vue?vue&type=template&id=3e29491e&scoped=true"
import script from "./notification-bar.ts?vue&type=script&lang=ts&external"
export * from "./notification-bar.ts?vue&type=script&lang=ts&external"
import style0 from "./notification-bar.scss?vue&type=style&index=0&id=3e29491e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e29491e",
  null
  
)

export default component.exports